<template>
  <div :class="`video-center ${orientation}`">
    <card-minimal title="Video" :class="`${orientation === 'portrait' ? 'w-100p w-md-50p w-lg-40p' : ''}`">
      <div class="player-outer">
        <div class="video-info f-1" v-if="status.status === 'complete'">
          <p>Video length</p>
          <p class="time">{{ time }}</p>
        </div>
        <div class="player-wrapper f-2">
          <template v-if="status.status === 'complete'">
            <Player :data="videoData" @duration="timeupdate" v-if="videoData" ref="player" />
          </template>
          <template v-else-if="status.status === 'error'">
            <div class="p-a-4 d-f ai-c jc-c fd-c">
              <i class="icon-warning m-t-4" />
              <h2 class="m-t-2">Seems like there was an issue with your video:</h2>
              <p class="m-t-1 m-b-4">{{ status.message }}</p>
            </div>
          </template>
          <template v-else>
            <div class="p-a-4 d-f ai-c jc-c fd-c">
              <div class="loading-spinner large m-t-4"></div>
              <h2 class="m-t-4">Your video will be ready as soon it has been encoded.</h2>
              <p class="m-t-1 m-b-4">In the meantime you can change <a class="link blue" @click="$router.push(`/video/${video.id}/settings`)">settings</a> like title and description.</p>
            </div>
          </template>
        </div>
      </div>
    </card-minimal>
  </div>
</template>

<script>

import moment from 'moment';

import Player from '@/components/Player/Video.vue';

export default {
  components: {
    Player,
  },
  computed: {
    /**
     * Return current status and message of video status
     * @returns {Object}
     */
    status() {
      const {
        video: {
          status: {
            life_cycle_status,
            life_cycle_status_message,
          },
        },
      } = this;

      return {
        status: life_cycle_status,
        message: life_cycle_status_message,
      };
    },
    /**
     * Video
     * @return {?Object}
     */
    video() {
      return this.$store.getters['Video/current'];
    },
    /**
     * Return object with source and stuff
     * @returns {?Object}
     */
    videoData() {
      const {
        video: {
          resources,
        },
        fqdn,
      } = this;

      const source = { src: '', type: '' };

      const [hls] = resources.filter(resource => (resource.role === 'hls' ? resource : null));

      source.src = `https://${fqdn}.streamify.io/resources/${hls.value}`;
      source.type = 'application/x-mpegURL';

      if (source.src === '') {
        return null;
      }

      return {
        autoplay: true,
        controls: true,
        fluid: true,
        liveui: true,
        sources: [source],
      };
    },
  },
  methods: {
    /**
     * Update the time variable
     */
    timeupdate(time) {
      if (!this.video) {
        return;
      }

      const { height, width } = this.$refs.player.$el.getBoundingClientRect();
      this.orientation = height > width ? 'portrait' : 'landscape';

      const duration = moment.duration(time * 1000, 'millisecond');
      const hours = Math.floor(duration.asHours()) >= 10 ? Math.floor(duration.asHours()) : `0${Math.floor(duration.asHours())}`;
      const minutes = Math.floor(duration.minutes()) >= 10 ? Math.floor(duration.minutes()) : `0${Math.floor(duration.minutes())}`;
      const seconds = Math.floor(duration.seconds()) >= 10 ? Math.floor(duration.seconds()) : `0${Math.floor(duration.seconds())}`;
      this.time = `${hours}:${minutes}:${seconds}`;
    },
  },
  data() {
    return {
      time: '',
      orientation: 'landscape',
    };
  },
};
</script>

<style lang="scss" scoped>
.video-center {
  &.landscape {
    .player-outer {
      display: flex;
    }

    .video-info {
      order: 2;
    }
  }

  i {
    font-size: 60px;
    color: var(--color-cta-red);
  }

  h2 {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
    line-height: 24px;
  }

  .video-info {
    padding: 15px;

    .info-title {
      margin-right: 10px;
    }

    .time {
      font-size: 48px;
      color: #000000;
      line-height: 64px;
      font-weight: 400;
      transition: all;
      transition-duration: 500ms;
      transition-delay: 500ms;
    }
  }
}
</style>
